import {
  MaterialCountStateTypes,
  MaterialCountActionTypes,
} from "./MaterialCount.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialCountStateTypes = {
  fetchAll: resetApiCallState([]),
  bulkUpsert: resetApiCallState({}),
};

const MaterialCountReducer = (
  state: MaterialCountStateTypes = INITIAL_STATE,
  action: any
): MaterialCountStateTypes => {
  switch (action.type) {
    case MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialCountActionTypes.FETCH_ALL_MATERIAL_COUNT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------------------------

    case MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT_RESET:
      return {
        ...state,
        bulkUpsert: resetApiCallState({}),
      };
    case MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT_FAILURE:
      return {
        ...state,
        bulkUpsert: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialCountActionTypes.BULK_UPSERT_MATERIAL_COUNT_SUCCESS:
      return {
        ...state,
        bulkUpsert: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialCountReducer;
